<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="配置id">
              <j-input placeholder="请输入配置id模糊查询" v-model="queryParam.setId" type="like"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="表名">
              <a-input placeholder="请输入表名" v-model="queryParam.dataTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <j-dict-select-tag placeholder="请选择状态" v-model="queryParam.status" dictCode="data_sync_log_status"/>
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item label="同步开始时间" :required="true">
              <j-date
                placeholder="请选择开始日期"
                class="query-group-cust"
                v-model="queryParam.startTime_begin"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                :showTime="true"
              ></j-date>
              <span class="query-group-split-cust"></span>
              <j-date
                placeholder="请选择结束日期"
                class="query-group-cust"
                v-model="queryParam.startTime_end"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                :showTime="true"
              ></j-date>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="批次号">
              <a-input placeholder="请输入批次号" v-model="queryParam.batchNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="筛选有同步数据">
              <j-dict-select-tag placeholder="是否筛选有同步数据" v-model="queryParam.filterZero" dictCode="yn"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:1710}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

      </a-table>
    </div>

    <busDataSyncBaseLog-modal ref="modalForm" @ok="modalFormOk"></busDataSyncBaseLog-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDate from '@/components/jeecg/JDate.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput'
  import moment from 'moment'

  export default {
    name: "BusDataSyncBaseLogList",
    mixins:[JeecgListMixin],
    components: {
      JDate,
      JInput
    },
    data () {
      return {
        description: '基础资料数据同步日志表管理页面',
        // 禁用进入页面自动加载数据
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'配置id',
            align:"center",
            dataIndex: 'setId'
          },
          {
            title:'表名',
            align:"center",
            dataIndex: 'dataTable'
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'同步开始时间',
            align:"center",
            dataIndex: 'startTime'
          },
          {
            title:'同步结束时间',
            align:"center",
            dataIndex: 'endTime'
          },
          {
            title:'源头数据库code',
            align:"center",
            dataIndex: 'sourceCode'
          },
          {
            title:'源头数据库名称',
            align:"center",
            dataIndex: 'sourceName'
          },
          {
            title:'目标数据库code',
            align:"center",
            dataIndex: 'targetCode'
          },
          {
            title:'目标数据库名称',
            align:"center",
            dataIndex: 'targetName'
          },
          {
            title:'同步的数据量',
            align:"center",
            dataIndex: 'syncNum'
          },
          {
            title:'错误消息',
            align:"center",
            dataIndex: 'errorMessage'
          },
          {
            title:'是否是删除表的同步',
            align:"center",
            dataIndex: 'delTableFlag_dictText'
          },
          {
            title:'错误位置',
            align:"center",
            dataIndex: 'errorLocation'
          },
          {
            title:'批次号',
            align:"center",
            dataIndex: 'batchNo'
          },
          {
            title:'日志id',
            align:"center",
            dataIndex: 'id'
          }
        ],
        url: {
          list: "/base/busDataSyncBaseLog/list",
        },
        dictOptions:{},
      }
    },
    computed: {
    },
    methods: {
      initDictConfig(){
      },
      // 初始化默认时间（最近一天）
      initDefaultTime() {
        const endTime = moment().format('YYYY-MM-DD HH:mm:ss')
        const startTime = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        this.$set(this.queryParam, 'startTime_begin', startTime)
        this.$set(this.queryParam, 'startTime_end', endTime)
      },
      // 覆盖查询方法，添加必填验证
      searchQuery() {
        if (!this.queryParam.startTime_begin || !this.queryParam.startTime_end) {
          this.$message.warning('请选择同步开始时间')
          return
        }
        // 调用 mixin 的查询方法
        this.loadData(1)
      }
    },
    mounted() {
      // 初始化默认时间
      this.initDefaultTime()
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>